import React from "react";
import "./SearchPage.css";
// import { IoIosHelpCircleOutline } from "react-icons/io";
import { useNavigate } from "react-router";
import { Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { useContext } from "react";
import { techappContext } from "../../Api/techappReq";
import Layout from "../../layout";
import { FaTimes } from "react-icons/fa";

const SearchPage = () => {
  const navigate = useNavigate();
  const { searchOrder, searchResult } = useContext(techappContext);
  const search = (e) => {
    searchOrder(e.target.value);
  };

  return (
    <Layout>
      <div className="techapp-search-page">
        <div className="tech-app-header">
          <span style={{ marginLeft: "auto" }}>جست و جو</span>
          <FaTimes
            onClick={() => {
              navigate("/techapp");
            }}
            style={{ marginRight: "25px" }}
          />
        </div>
        <Input
          placeholder={"جست و جو در سفارش ها"}
          suffix={<SearchOutlined onClick={(e) => search(e)} />}
          className="techapp-search-input"
          onPressEnter={(e) => search(e)}
        />
        {!searchResult && (
          <span style={{ fontSize: "20px", marginTop: "100px" }}>
            سفارشی یافت نشد!
          </span>
        )}
      </div>
    </Layout>
  );
};
export default SearchPage;
